import { InsuranceCategory } from '../../core/data/dtos/insurance-type.dto';

/**
 * Returns a human readable label for an InsuranceCategory value.
 */
export function getCategoryLabel(category?: InsuranceCategory | null): string {
  switch (category) {
    case InsuranceCategory.Life:
      return 'Seguro de Vida';
    case InsuranceCategory.Health:
      return 'Seguro de Salud';
    case InsuranceCategory.Accident:
      return 'Accidentes Personales';
    default:
      return 'Seguro';
  }
}
